import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import { Link } from "react-router-dom";
import Spinner from 'react-bootstrap/Spinner';
import { useNavigate, useParams } from 'react-router-dom';
import { NavLink } from "react-router-dom";
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { Form } from "react-bootstrap";
import moment from "moment";
import UserGroupDropDown from "../Shared/UserGroupDropDown";
import Examination_navbar from './Examination_navbar';
import SubjectTypesDropDown from "../Shared/SubjectTypesDropDown";
import SessionsDropDown from "../Shared/SessionsDropDown";
import { scrollToTop } from '../Shared/ScrollOnTop';

function EditExam() {
    const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
    const [UserID, setUserID] = useState(localStorage.getItem("ID"));
    const [MemberType, setMemberType] = useState(localStorage.getItem("MemberType"));
    const [validated, setValidated] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [hasError, setHasError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [Exams, setExams] = useState({});
    const [DefaultSession, setDefaultSession] = useState(localStorage.getItem("DefaultSession"));


    let params = useParams();
    const [ExamID, setExamID] = useState(params.id);

    let navigate = useNavigate();

    useEffect(() => {
        document.title = "Add/Update Examination";
        setLoading(true);
        const data = {
            AccessKey: AccessKey,
            UserID: UserID,
            MemberType: MemberType,
            ID: ExamID

        };
        ////console.log(data);
        var api_config = {
            method: 'post',
            url: config.base_url + 'Exam/GetExamByID',
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };


        axios(api_config)
            .then(function (response) {
                //console.log(response.data);
                if (response.data.status_code == 1) {

                    setExams(response.data);
                }
                setLoading(false);
            })
            .catch(function (error) {
                setLoading(false);
                toast.error('Network Error..', {
                    position: toast.POSITION.TOP_RIGHT
                });
            });


    }, []);

    const handleSubmit = (event) => {

        event.preventDefault();
        event.stopPropagation();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        }
        else {
            setLoading(true);
            const data = {
                AccessKey: AccessKey,
                UserID: UserID,
                MemberType: MemberType,
                ID: ExamID,
                Name: event.target.txtName.value,
                Print_Title: event.target.txtPrintTitle.value,
                Start_Date: event.target.txtStartDate.value,
                End_Date: event.target.txtEndDate.value,
                Current_Status: event.target.txtCurrentStatus.value,
                Exam_Code: event.target.txtExamCode.value,
                Exam_Type: event.target.txtExamType.value,
                Session_ID: DefaultSession
            };

            //console.log(data);

            var api_config = {
                method: 'post',
                url: config.base_url + '/Exam/UpdateExam',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };

            axios(api_config)
                .then(function (response) {
                    //console.log(response.data);
                    if (response.data.status_code == 1) {
                        toast.success(response.data.status_message, {
                            position: toast.POSITION.TOP_RIGHT
                        });

                    }
                    else {
                        toast.error(response.data.status_message, {
                            position: toast.POSITION.TOP_RIGHT
                        });
                    }
                    setLoading(false);
                })
                .catch(function (error) {
                    setLoading(false);
                    toast.error('Network Error..', {
                        position: toast.POSITION.TOP_RIGHT
                    });
                });

        }
        setValidated(true);
    };


    return (
        <>
            <Examination_navbar />
            <ToastContainer />
            <div className="page-head">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/Dashboard">Dashboard</Link></li>
                                    <li className="breadcrumb-item"><Link to="/ExaminationSystem/ExaminationDashboard">Examination</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Edit Examination</li>
                                </ol>
                            </nav>
                            <div className="page-title">Edit Examination</div>
                        </div>
                        <div className="col-md-6">
                            <div className="page-right-actions">
                                <Link to="/ExaminationSystem/ManageExaminations" className="button button-white button-icon">
                                    Manage Examinations
                                    <i className="ri-list-check"></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="page-content">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-body p-md-4">
                                    {
                                        loading ?
                                            <Spinner animation="border" role="status"></Spinner>
                                            :
                                            <Form noValidate validated={validated} onSubmit={handleSubmit}>
                                                <div className="row align-items-center">
                                                    <div className="col-md-2">
                                                        <div className="form-group mb-3">
                                                            <label >Exam Code:</label>
                                                            <input type="text" defaultValue={Exams.Exam_Code} className="form-control" required name="txtExamCode" />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-5">
                                                        <div className="form-group mb-3">
                                                            <label  className="">Exam Name:</label>
                                                            <input type="text" defaultValue={Exams.Name} className="form-control" required name="txtName" />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-5">
                                                        <div className="form-group mb-3">
                                                            <label  className="">Exam Title:</label>
                                                            <input type="text" defaultValue={Exams.Print_Title} className="form-control" required name="txtPrintTitle" />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group mb-3">
                                                            <label  className="">Current Status:</label>
                                                            <select className="form-select"
                                                                required value={Exams.Current_Status} name="txtCurrentStatus">
                                                                <option value="">Please Select</option>
                                                                <option value="Announced">Anounced</option>
                                                                <option value="Current">InProgress</option>
                                                                <option value="Finished">Finished</option>
                                                                <option value="Delayed">Delayed</option>
                                                                <option value="Cancelled">Cancelled</option>
                                                                <option value="Terminated">Terminated</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group mb-3">
                                                            <label  className="">Start Date:</label>
                                                            <input type="date" defaultValue={moment(Exams.Start_Date).format(config.date_format_input)}
                                                                className="form-control" required name="txtStartDate" />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group mb-3">
                                                            <label  className="">End Date:</label>
                                                            <input type="date" defaultValue={moment(Exams.End_Date).format(config.date_format_input)}
                                                                className="form-control" required name="txtEndDate" />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group mb-3">
                                                            <label  className="">Exam Type:</label>

                                                            <select className="form-select" required defaultValue={Exams.Exam_Type} name="txtExamType">
                                                                <option value="">Please Select</option>
                                                                <option value="1st Term Annual">1st Term Annual</option>
                                                                <option value="2nd Term Annual">2nd Term Annual</option>
                                                                <option value="3rd Term Annual">3rd Term Annual</option>
                                                                <option value="Class Test">Class Test</option>
                                                                <option value="Cancelled">Cancelled</option>
                                                                <option value="Terminated">Terminated</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group mb-3">
                                                            <label  className="">Session:</label>
                                                            <select className="form-select" required>
                                                                <option value="">Please Select</option>
                                                                <SessionsDropDown selectedSession={DefaultSession} />
                                                            </select>
                                                        </div>
                                                    </div>


                                                    <div className="col-md-2 offset-md-7 text-end">
                                                        <div className="form-group ">
                                                            {
                                                                loading ?
                                                                    <Spinner animation="border" role="status"></Spinner>

                                                                    :
                                                                    <button type="submit" value="Save" className="button button-primary w-100 ">SAVE</button>

                                                            }

                                                        </div>
                                                    </div>
                                                </div>
                                            </Form>
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default EditExam;
